import { createContext } from "react";

const noteContext = createContext()
// i will put all the states of note here so that all the components get 
// access to the states whteher they are drilled to much (child)

export default noteContext